/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `date` - Date * `boolean` - Boolean * `number` - Number * `choice` - Choice * `text` - Text * `country` - Country * `relation` - Relation
 */
export type FieldTypeEnum = 'date' | 'boolean' | 'number' | 'choice' | 'text' | 'country' | 'relation';

export const FieldTypeEnum = {
    Date: 'date' as FieldTypeEnum,
    Boolean: 'boolean' as FieldTypeEnum,
    Number: 'number' as FieldTypeEnum,
    Choice: 'choice' as FieldTypeEnum,
    Text: 'text' as FieldTypeEnum,
    Country: 'country' as FieldTypeEnum,
    Relation: 'relation' as FieldTypeEnum
};